const SUB_DIRECTORY = "/indexing";

export const SEARCH_SKU_NAME = `${SUB_DIRECTORY}/searchSkuName`;
